// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".course-resume-empty[data-v-6e0b0935]{animation:courseResumeEmptyIn-6e0b0935 .35s ease-out}@keyframes courseResumeEmptyIn-6e0b0935{0%{opacity:0;transform:translateY(6px)}to{opacity:1;transform:translateY(0)}}@media (prefers-reduced-motion:reduce){.course-resume-empty[data-v-6e0b0935]{animation:none}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
